import { render, staticRenderFns } from "./multiPrice.vue?vue&type=template&id=830ed71e&scoped=true&"
import script from "./multiPrice.vue?vue&type=script&lang=js&"
export * from "./multiPrice.vue?vue&type=script&lang=js&"
import style0 from "./multiPrice.vue?vue&type=style&index=0&id=830ed71e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "830ed71e",
  null
  
)

export default component.exports